module.exports = __webpack_public_path__ + "img/t4-6.2be90f1e.svg";